import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import '../tailwind.css';
import './index.css';

/**
 * SPA Refresh Handler
 * Check if we were redirected from a sub-path via 404.html
 */
const redirectPath = sessionStorage.getItem('redirectPath');
if (redirectPath) {
  sessionStorage.removeItem('redirectPath');
  window.history.replaceState(null, '', redirectPath);
}

/**
 * Application entry point
 * Initializes the React application and mounts it to the DOM
 * Includes both Tailwind CSS and custom CSS styles
 */

// Get the root DOM element where the React app will be mounted
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the App component inside StrictMode for development checks
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 